import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service, OsbStudy } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { OauthService } from '../../../../services/oauth.service';
import { DbService } from '../../../../services/db.service';

type CreateStudyInput = {
  study_name: string;
  study_title?: string;
  study_description: string;
}

@Component({
  selector: 'app-create-study',
  imports: [],
  templateUrl: './create-study.component.html',
  styleUrl: './create-study.component.css'
})
export class CreateStudyComponent implements StateComponent, OnInit, OnDestroy {
  stateName = "CreateStudy";
  private usdmSub: Subscription | null = null;
  data: CreateStudyInput | null = null;
  publicOsbStudyId: string | null = null;
  maxStudyNumber: number = 0;

  constructor(private usdm: Usdm2Service, private http: HttpClient, private oauth: OauthService, private db: DbService) { }

  async ngOnInit(): Promise<void> {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'FinishResponse') {
        this.data = item.result as CreateStudyInput;
        this.createStudy();
      }
    });
  }

  async createStudy(): Promise<void> {
    if (!this.data) {
      return;
    }
    const response = await lastValueFrom(this.http.get<OsbStudy[]>(`${environment.osburl}/api/studies/list?minimal=true`, {}));
    for (const item of response) {
      if (item?.id && typeof item.id === 'string' && item.id.startsWith('999-')) {
        const n = parseInt(item.id.substring(4), 10);
        if (!Number.isNaN(n) && n > this.maxStudyNumber) {
          this.maxStudyNumber = n;
        }
      }
    }
    this.publicOsbStudyId = String(this.maxStudyNumber + 1);
    this.usdm.publicOsbStudyId = "999-" + this.publicOsbStudyId;
    console.log('Current study number:', this.usdm.publicOsbStudyId);

    const payload = {
      "study_acronym": this.data?.study_name.slice(0, 20),
      "study_subpart_acronym": null,
      "description": this.data?.study_description,
      "study_parent": null,
      "study_parent_part_uid": ["999"],
      "study_description": { "study_title": this.data?.study_name },
      "project_number": "999",
      "study_number": this.publicOsbStudyId,
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const postResponse: any = await lastValueFrom(this.http.post(`${environment.osburl}/api/studies`, payload));
    if (postResponse) {
      this.usdm.privateOsbStudyId = postResponse.uid;
      console.log('OSB study ID:', this.usdm.privateOsbStudyId);
      // OSB ignores study_description on create, so the title must be patched in.
      try {
        await lastValueFrom(this.http.patch(`${environment.osburl}/api/studies/${postResponse.uid}`, {
          current_metadata: {
            study_description: {
              study_title: this.data.study_title || this.data.study_name,
              study_short_title: this.data.study_name,
            },
          },
        }));
      } catch (error) {
        console.error('Error setting OSB study title:', error);
      }
    }

    const sessionId = this.usdm.sessionId;
    try {
      const data = await this.db.updateUsdmSession(sessionId, {
        osb_study_id: this.usdm.publicOsbStudyId,
      });
      console.log('USDM session updated successfully', data);
    } catch (error) {
      console.error('Error updating USDM session:', error);
    } finally {
      this.usdm.signalStateCompletion(this.stateName);
    }
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }
}
